export default __webpack_public_path__ + "static/teaching-6a0a31db9a0c3ff427c4b1916d849ab9.jpg";